import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import parse from 'html-react-parser';
// import { Link } from 'gatsby';
import IconsHolder from '../icons-holder/IconsHolder';
import { removeExtraSpaces } from '../../scripts/helpers';
var FontIconCards = /*#__PURE__*/function (_React$Component) {
  function FontIconCards() {
    _classCallCheck(this, FontIconCards);
    return _callSuper(this, FontIconCards, arguments);
  }
  _inherits(FontIconCards, _React$Component);
  return _createClass(FontIconCards, [{
    key: "render",
    value: function render() {
      var _this = this;
      var cards = this.props.cards;
      var classN = this.props.className || '';
      var CustomHeadingTag = this.props.headingTag || 'h3'; // start with capital
      var variant = function variant() {
        var color = 'card-light';
        if (Object.prototype.hasOwnProperty.call(_this.props, 'variant')) {
          color = _this.props.variant === 'dark' ? 'card-dark' : color;
        }
        return color;
      };
      var variantIcon = function variantIcon() {
        // 'light'| 'primary' |'danger'|'success'
        var icon = 'primary';
        if (Object.prototype.hasOwnProperty.call(_this.props, 'variant')) {
          icon = _this.props.variant === 'dark' ? 'light' : icon;
        }
        return icon;
      };
      var returnColClass = function returnColClass() {
        var cardsNumber = _this.props.cardsPerPage || cards.length;
        if (cardsNumber === 3) {
          return 'col-lg-4';
        }
        if (cardsNumber === 6) {
          return 'col-md-6 col-lg-4';
        }
        if (cardsNumber === 8) {
          return 'col-md-6 col-xl-3';
        }
        return 'col-md-6';
      };
      var returnRowClass = function returnRowClass() {
        var cardsNumber = _this.props.cardsPerPage || cards.length;
        if (cardsNumber === 3) {
          return 'gy-lg-0';
        }
        if (cardsNumber === 4) {
          return 'gy-lg-4';
        }
        if (cardsNumber === 6) {
          return 'gy-lg-4';
        }
        if (cardsNumber === 8) {
          return 'gy-lg-4';
        }
        return 'gy-md-0';
      };
      return React.createElement("div", {
        className: "row gy-3 ".concat(returnRowClass(), " ").concat(classN)
      }, cards.map(function (element, i) {
        var _this$props;
        var CardTag = element.link ? 'a' : 'div';
        return React.createElement("div", {
          key: element.id || element.dataLink || "".concat(i, "-step-icon-card"),
          className: removeExtraSpaces("col-12 ".concat(returnColClass()))
        }, React.createElement(CardTag, _objectSpread(_objectSpread(_objectSpread({
          className: "card ".concat(variant(), " ").concat(element.subcopy ? '' : 'align-items-center', " ").concat(element.link ? 'card-link ' : '')
        }, element.link ? {
          href: element.link
        } : {}), element.dataOp ? {
          'data-op': element.dataOp
        } : {}), element.dataLink ? {
          'data-link-both': element.dataLink
        } : {}), element.icon ? React.createElement(IconsHolder, {
          icon: element.icon,
          variant: variantIcon(),
          size: "lg",
          className: "me-3"
        }) : null, element.subcopy ? React.createElement("div", null, React.createElement(CustomHeadingTag, {
          className: "h5 ".concat(element.subcopy ? '' : 'mb-0')
        }, typeof element.heading === 'string' ? parse(element.heading) : element.heading), React.createElement("p", {
          className: "".concat(((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.variant) === 'dark' ? 'text-white text-opacity-70' : 'text-gray', " mb-0")
        }, typeof element.subcopy === 'string' ? parse(element.subcopy) : element.subcopy)) : React.createElement(CustomHeadingTag, {
          className: "h5 mb-0"
        }, typeof element.heading === 'string' ? parse(element.heading) : element.heading)));
      }));
    }
  }]);
}(React.Component);
export default FontIconCards;
/* // REPLACE WITH GATSBY LINK
            {element.gatsbyLink ? (
              <Link
                to={element.link}
                {...(element.dataLink ? { 'data-link-both': element.dataLink } : {})}
                className={`card card-link ${variant()} ${element.label || element.subcopy ? '' : 'align-items-center'}`}>
                {commonContent(element)}
              </Link>
            ) : (  )} */